import React from 'react';
import styles from './assets/footer.module.scss';
import classNames from 'classnames';

const Footer: React.FunctionComponent = React.memo(() => {
    return (
        <footer className={classNames(styles.footer)}>
            <div className={classNames(styles.bottom)}>
                <div className={classNames(styles.bottomHolder)}>
                    <span>
                        &copy; COPYRIGHT {new Date().getFullYear()}{' '}
                        {window?.location?.origin === 'https://mpgtutoring.providerpoint.net'
                            ? 'MPG TUTORING, INC'
                            : 'MANHATTAN PSYCHOLOGY GROUP, PC'}{' '}
                        · ALL RIGHTS RESERVED
                    </span>
                </div>
            </div>
        </footer>
    );
});

export default Footer;
